import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { TextareaField } from '@anytag/shared-molecules';
import { InfluencerFormKeys } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

export const InternalMemoField = () => {
  const { t } = useTranslation();
  const { isAdminStaff } = useUserRoles();

  return (
    <TextareaField<InfluencerFormKeys>
      name={InfluencerSharedKeys.internalMemo}
      title={<span className="text-red-70">{t('InternalMemoOnProfileForm')}</span>}
      help={t(isAdminStaff ? 'Tooltip.Internal Memo Help Admin&Staff' : 'Tooltip.Internal Memo Help External Users')}
    />
  );
};
